import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';

import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import OrderPreview from '../OrderPreview';
import Order from '../../../models/Order';
import UIStore from '../../../store/UIStore';
import RecurringOrder from '../../../models/RecurringOrder';
import RecurringOrderPreview from '../RecurringOrderPreview';

@observer
export class OrderList extends Component {
  renderOrderRows = () => {
    const { orders, useRecurringOrders, onRemoveClick } = this.props;

    return orders.map((order) => {
      return useRecurringOrders ? (
        <RecurringOrderPreview
          key={order.id}
          order={order}
          onRemoveClick={onRemoveClick}
        />
      ) : (
        <OrderPreview key={order.id} order={order} />
      );
    });
  };

  renderHeaders = () => {
    const { useRecurringOrders } = this.props;

    return (
      <div className="OrderList__headers">
        <Row>
          <Col md={useRecurringOrders ? 5 : 4}>
            <FormattedMessage {...globalTranslations.orderInfoHeader} />
          </Col>
          {!useRecurringOrders && (
            <Col md="2">
              <FormattedMessage
                id="order.dateHeader"
                defaultMessage="Order date"
              />
            </Col>
          )}
          <Col md="2">
            <FormattedMessage
              id="order.trackingHeader"
              defaultMessage="Status"
            />
          </Col>
          <Col md={useRecurringOrders ? 3 : 2}>
            <FormattedMessage id="order.sumHeader" defaultMessage="Total" />
          </Col>
          <Col md="2" />
        </Row>
      </div>
    );
  };

  renderOrders = () => {
    const { orders, uiStore } = this.props;

    if (orders.length === 0) {
      return <FormattedMessage {...globalTranslations.myAccountNoOrders} />;
    }

    return (
      <Fragment>
        {!uiStore.isMobile && this.renderHeaders()}
        {this.renderOrderRows()}
      </Fragment>
    );
  };

  render() {
    return <div className="OrderList">{this.renderOrders()}</div>;
  }
}

OrderList.propTypes = {
  orders: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Order)),
    MobxPropTypes.observableArrayOf(modelOf(RecurringOrder)),
    PropTypes.array
  ]),
  uiStore: modelOf(UIStore).isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  useRecurringOrders: PropTypes.bool
};

export default inject('uiStore', 'recurringOrderStore')(OrderList);



// WEBPACK FOOTER //
// ./src/components/order/OrderList/index.jsx